import React, {useEffect, useState} from "react";
import { Form, Radio, Select,Row, Col, Space} from 'antd';
import GenericDialog from '@common/GenericDialog';
import axios from "@common/axios";

const { Option } = Select;

const CopyTestsDialog = ({
                             open,
                             onSearch,
                             onClose,
                             selectedTest,
                         }) => {

    const [copyTestForm] = Form.useForm();

    const handleCopyTest = async () => {
        const fieldValues = copyTestForm.getFieldsValue(),
            questionOrder = fieldValues.questionOrder;

        copyTestForm.validateFields();
        return copyTest(selectedTest.testId, questionOrder);
    }

    const copyTest = async (testId, randomiseQuestions) => {
        await axios.post('/controlCentre/copyTest.action', null, {
            params: {
                testId: testId,
                randomiseQuestions: randomiseQuestions,
            }
        })
            .then(response => {
                displayToastMessage('Assessment has been copied', '', 'success');
            }).catch((error) => {
                console.error('Error copying test: ', error);
            }).finally(() => {
                onSearch();
                onClose();
            });
    }

    return (
        <GenericDialog
            title={`Copy: ${selectedTest?.name || ""}`}
            open={open}
            onClose={onClose}
            buttons={[
                { name: "Cancel", extraProps: { type: "text" } },
                { name: "Copy", callback: handleCopyTest },
            ]}
        >
            <Form form={copyTestForm} initialValues={{ questionOrder: false }} preserve={false}>
                <Space orientation="vertical">
                    <Form.Item label="Question order" name="questionOrder">
                        <Radio.Group
                            buttonStyle={'solid'}
                            options={[
                                { label: "Keep", value: false },
                                { label: "Randomise", value: true },
                            ]}
                            optionType="button"
                        />
                    </Form.Item>
                </Space>
            </Form>
        </GenericDialog>
    );
};

export default CopyTestsDialog;
